import { graphql, useFragment } from 'react-relay';
import { getUserGeoInfo } from './regionalInfoHelpers';

import { useUserGeoInfo_user$key } from './__generated__/useUserGeoInfo_user.graphql';

type ReturnType = {
    countryCode: string | null;
    zipCode: string | null;
};

export const useUserGeoInfo = (userRef: useUserGeoInfo_user$key | null): ReturnType => {
    const userGeoInfo = getUserGeoInfo();

    const user = useFragment(
        graphql`
            fragment useUserGeoInfo_user on User {
                addressBook {
                    addressList {
                        country
                        zipCode
                    }
                    proAddress {
                        country
                        zipCode
                    }
                    personalAddress {
                        country
                        zipCode
                    }
                }
            }
        `,
        userRef
    );

    const { addressBook } = user || {};
    const { proAddress, personalAddress, addressList } = addressBook || {};

    if (proAddress) {
        return {
            countryCode: proAddress?.country,
            zipCode: proAddress?.zipCode,
        };
    } else if (personalAddress) {
        return {
            countryCode: personalAddress?.country,
            zipCode: personalAddress?.zipCode,
        };
    } else if (addressList?.[0]) {
        return {
            countryCode: addressList[0]?.country,
            zipCode: addressList[0]?.zipCode,
        };
    } else if (userGeoInfo) {
        return {
            countryCode: userGeoInfo.countryCode,
            zipCode: userGeoInfo.zipCode,
        };
    }

    return { countryCode: null, zipCode: null };
};
